import { graphql } from "@/gql/assistant";

export const GetCurrentUserRoles = graphql(`
  query GetCurrentUserRoles {
    me {
      profile {
        id
        roles {
          id
          name
          __typename
        }
        __typename
      }
    }
  }
`);